module.exports = __webpack_public_path__ + "img/restore.31f1376b.svg";